import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getBannerLoading } from "../../../../Redux/BannerLoading/BannerLoadingSlice";
import { log } from "video.js";
import Translate from "../../../../Components/Multilanguage/Translate";
import BannerUtil from "../util.jsx";
import { imageUrlCheck } from "../../../../utils/utils";
import playButton from "../../../../assets/Images/play.png"
import { ReactComponent as AddToPlaylistIcon } from "../../../../assets/Icons/addToList.svg";
import { ReactComponent as RemoveFromPlaylistIcon } from "../../../../assets/Icons/removeFromList.svg";
import { ReactComponent as AddToPlaylistIcon2 } from "../../../../assets/Icons/addToList2.svg";
import { ReactComponent as RemoveFromPlaylistIcon2 } from "../../../../assets/Icons/removeFromList2.svg";
const SwiperItem = ({ data }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const dispatch = useDispatch()
  const [isImageLoad, setIsImageLoad] = useState(false);
  const buttonTextColor = projectInfo?.projectConfig?.config?.BUTTON_TEXT_COLOR ;
  const textColor = projectInfo?.projectConfig?.config?.TEXT_COLOR; 
  const theme = projectInfo?.projectConfig?.config?.THEME;
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const navigate = useNavigate();
  const { afterImageLoad, replaceImage, playClickHandler, updateWatchlist } = BannerUtil();
  const [watchlistStatus, setWatchlistStatus] = useState({ [data?.show_id]: data?.watchlist_flag ?? 0 });
  const kids = template === 'TEMPLATE_12';
  const hasImageTitle = data?.image_title && imageUrlCheck(`${data.image_title}`);

  useEffect(()=>{
    return ()=>{
      dispatch(
        getBannerLoading({
          bannerLoading:false
        })
      )
    }
  },[])

  useEffect(()=>{
    setWatchlistStatus({ [data?.show_id]: data?.watchlist_flag ?? 0 });
  },[data]);


  return (
    <div className={!isImageLoad?"bannerContainer loading":"bannerContainer"}>
      <div className="fadeGradientBottom"></div> 
      <div className={`left ${kids ? 'kids' : ''}`}>
        <div className="contents">
          <h1 className={`title ${hasImageTitle ? 'hasImageTitle' : ''} ${theme === "LIGHT" ? "light-theme-text" : ""} ${projectInfo?.projectConfig?.pubid === 50147 ? 'template-11-font' : (projectInfo?.projectConfig?.pubid === 50167) ? 'template-12-font' : ''}`}>
            {hasImageTitle ? (
                <img src={`${data.image_title}`} alt={data.image_title || data.show_name} className="titleImage" />
              ) : (
                data?.show_name
            )}
          </h1>
           <div className="genres">
              {projectInfo?.projectConfig?.pubid !== 50119 &&
               data?.categories
                ?.filter(item => item?.category_name)
                .map((item, index) => (
                  <span key={index}>{item.category_name}</span>
                ))
              }
           </div>
          {(data?.synopsis || kids) && <p className="description">{data?.synopsis}</p>}
          <span className="duration">{data?.duration_text}</span>
          <div className="buttonsWrapper">
            <div className="buttonContainer" onClick={() => playClickHandler(data)}>
              { projectInfo?.projectConfig?.pubid === 50147 ? (
                <img src={playButton} alt="Play" className="playButton" />
              ) : (
                <>
                  <div className="background"></div>
                  <button className={`watchNowButton ${theme === 'LIGHT' ? 'light-theme-button' : ''}`}style={{ color: projectInfo?.projectConfig?.config?.TEMPLATE === 'TEMPLATE_9' || projectInfo?.projectConfig?.config?.TEMPLATE === 'TEMPLATE_12' ? buttonTextColor : textColor }}>
                    <Translate textKey={'watch_now'}/>
                  </button>
                </>
              )}
            </div>           

            {kids && (
              watchlistStatus[data?.show_id] === 1 ? (
                <button
                  className="addToPlaylist"
                  aria-label={`Remove ${data?.show_name} from playlist`}
                  onClick={() => updateWatchlist(data?.show_id, 0, setWatchlistStatus)}
                >
                  <RemoveFromPlaylistIcon2 />
                </button>
              ) : (
                <button
                  className="addToPlaylist"
                  aria-label={`Add ${data?.show_name} to playlist`}
                  onClick={() => updateWatchlist(data?.show_id, 1, setWatchlistStatus)}
                >
                  <AddToPlaylistIcon2 />
                </button>
              )
            )}

            {data?.show_trailer && <div className="buttonContainer" onClick={() => playClickHandler(data, { isTrailer: true })}>
              <div className="Trailerbackground background"></div>
              <button className="trailerButton"><Translate textKey={'trailer'}/></button>
            </div>}
          </div>
        </div>
      </div>
      <div className="right">
        {!kids && <div className="fadeGradient"></div>}
        <div className={"imageContainer"}>
          {imageUrlCheck(data?.banner) ? (
            <img src={data?.banner} 
                 onError={(e) => replaceImage(e)} 
                 onLoad={(e) => {
                   setIsImageLoad(true);
                   afterImageLoad();
                 }} 
                 onClick={() => kids && playClickHandler(data)}
                 alt="BgImage" />
          ) : (
            <img src={`${process.env.REACT_APP_IMAGE_URL}${data?.banner}`} 
                 onError={(e) => replaceImage(e)} 
                 alt="BgImage"  />
          )}
       
        </div>
      </div>
    </div>
  );
};

export default SwiperItem;